import { render, staticRenderFns } from "./comment-view-page.vue?vue&type=template&id=3a6059f7&"
import script from "./comment-view-page.vue?vue&type=script&lang=js&"
export * from "./comment-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports